/**
 * PRD §18 — "Powered by Xotski" watermark.
 *
 * Renders 8px below every game surface, centered, 11px font, low opacity
 * so it never competes with brand branding. The component is intentionally
 * minimal — no MUI / no design-system dep — so it ships with every game
 * mechanic without adding bytes to the consumer bundle.
 */
export function XotskiWatermark() {
  return (
    <p
      className="pointer-events-none mt-2 text-center text-[11px] tracking-widest opacity-50"
      aria-hidden
    >
      Powered by <span className="font-bold">Xotski</span>
    </p>
  );
}
